import type { ReactNode } from 'react'
import type { CustomWorkflowOutputField } from '../../store/customWorkflow/customWorkflows'
import type { OutputTypeHint } from './outputTypes'
import { WorkflowOutputField } from './WorkflowOutputField'
import { RunFileProvider } from './runFileContext'
import { CcqWorkflowOutputs } from './CcqWorkflowOutputs'
import { outputsHavePerClientArray } from './CcqWorkflowOutputs.helpers'

export const hintsFromSchema = (schema?: CustomWorkflowOutputField[]): Record<string, OutputTypeHint> =>
  Object.fromEntries((schema ?? []).map((field) => [field.variable, { valueType: field.valueType }]))

export const renderWorkflowOutputs = (
  outputs: Record<string, unknown>,
  hints?: Record<string, OutputTypeHint>,
  runFile?: { accountId: string; workflowId: string; runId: string },
): ReactNode => {
  const entries = Object.entries(outputs)
  if (entries.length === 0) {
    return <p className='zocks-text-gray-600 mb-0'>No outputs.</p>
  }
  if (runFile?.accountId && outputsHavePerClientArray(outputs)) {
    return <CcqWorkflowOutputs outputs={outputs} accountId={runFile.accountId} hints={hints} runFile={runFile} />
  }
  const fields = entries.map(([key, value]) => <WorkflowOutputField key={key} name={key} value={value} hint={hints?.[key]} />)
  return runFile ? <RunFileProvider value={runFile}>{fields}</RunFileProvider> : <>{fields}</>
}
